/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  TestServerConnectionRequestBody,
  TestServerConnectionRequestBody$Outbound,
  TestServerConnectionRequestBody$outboundSchema,
} from "../components/testserverconnectionrequestbody.js";

export type TestServerConnectionSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type TestServerConnectionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  testServerConnectionRequestBody: TestServerConnectionRequestBody;
};

/** @internal */
export type TestServerConnectionSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const TestServerConnectionSecurity$outboundSchema: z.ZodMiniType<
  TestServerConnectionSecurity$Outbound,
  TestServerConnectionSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function testServerConnectionSecurityToJSON(
  testServerConnectionSecurity: TestServerConnectionSecurity,
): string {
  return JSON.stringify(
    TestServerConnectionSecurity$outboundSchema.parse(
      testServerConnectionSecurity,
    ),
  );
}

/** @internal */
export type TestServerConnectionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  TestServerConnectionRequestBody: TestServerConnectionRequestBody$Outbound;
};

/** @internal */
export const TestServerConnectionRequest$outboundSchema: z.ZodMiniType<
  TestServerConnectionRequest$Outbound,
  TestServerConnectionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    testServerConnectionRequestBody:
      TestServerConnectionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      testServerConnectionRequestBody: "TestServerConnectionRequestBody",
    });
  }),
);

export function testServerConnectionRequestToJSON(
  testServerConnectionRequest: TestServerConnectionRequest,
): string {
  return JSON.stringify(
    TestServerConnectionRequest$outboundSchema.parse(
      testServerConnectionRequest,
    ),
  );
}
